'use client';

import Script from 'next/script';

import usePriorityAnimationDelay from '~/utils/usePriorityAnimationDelay';

const Calendly = () => {
  const isAnimationPending = usePriorityAnimationDelay();
  if (!isAnimationPending) {
    return (
      <>
        {/* Load Calendly CSS */}
        <link
          href="https://assets.calendly.com/assets/external/widget.css"
          rel="stylesheet"
        />
        {/* Load Calendly JS */}
        <Script
          src="https://assets.calendly.com/assets/external/widget.js"
          strategy="lazyOnload"
        />
      </>
    );
  }
  return null;
};

export default Calendly;
